/* eslint-disable max-lines */
// 診断システムID略称による抽出処理をまとめたユーティリティクラス(システム数が多いため、max-linesは許容)
/**
 * 診断システム分類のユーティリティ関数群。
 */
class DiagSystemUtils {

  /**
   * 診断システムID略称がエンジンに該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isEngineByAbbreviationId(abbreviationId) {
    return ['EGI'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がトランスミッションに該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isTransmissionByAbbreviationId(abbreviationId) {
    return ['TM'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がアイサイトアシストモニタに該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isEyesightAssistMonitorByAbbreviationId(abbreviationId) {
    return ['EAM'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がアイサイトに該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isEyesightByAbbreviationId(abbreviationId) {
    return ['ES'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がブレーキコントロールに該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isBrakeControlByAbbreviationId(abbreviationId) {
    return ['BC'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がボディコントロールに該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isBodyControlByAbbreviationId(abbreviationId) {
    return ['BIU'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がコックピットコントロールに該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isCockpitControlByAbbreviationId(abbreviationId) {
    return ['CCU'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がエアバッグに該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isAirbagByAbbreviationId(abbreviationId) {
    return ['AB'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がセントラルECUに該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isCentralEcuByAbbreviationId(abbreviationId) {
    return ['C-ECU'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称が電制ダンパーに該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isDamperByAbbreviationId(abbreviationId) {
    return ['DAM'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がキーレスエントリーに該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isKeylessEntryByAbbreviationId(abbreviationId) {
    return ['KLE'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がキーレスアクセス＆プッシュスタート(電源)に該当するか判定する。
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isPowerSupplyByAbbreviationId(abbreviationId) {
    return ['SMTP'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がパワーウィンドウ（スイッチ）に該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isPowerWindowSwitchByAbbreviationId(abbreviationId) {
    return ['PWS'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がドライバモニタに該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isDriverMonitorByAbbreviationId(abbreviationId) {
    return ['DMN'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がコンビネーションメータに該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isCombinationMeterByAbbreviationId(abbreviationId) {
    return ['MET'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がパワーシートメモリに該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isPowerSeatMemoryByAbbreviationId(abbreviationId) {
    return ['SEAT'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がドアミラー（運転席）に該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isDoorMirrorDriverByAbbreviationId(abbreviationId) {
    return ['MIRD'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がドアミラー（助手席）に該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isDoorMirrorPassengerByAbbreviationId(abbreviationId) {
    return ['MIRP'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がエアコンに該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isAirConditionerByAbbreviationId(abbreviationId) {
    return ['AC'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がタイヤ空気圧モニタに該当するか判定する。
   * (Protocol: Phase4/FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isTirePressureMonitorByAbbreviationId(abbreviationId) {
    return ['TPM'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がテレマティクスに該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isTelematicsByAbbreviationId(abbreviationId) {
    return ['TLM'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称が後側方警戒支援システムに該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isBlindSpotDetectionRearCrossTrafficAlertByAbbreviationId(abbreviationId) {
    return ['RVDR', 'RVDL'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がアクティブサウンドコントロールに該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isActiveSoundControlByAbbreviationId(abbreviationId) {
    return ['ASC'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がヘッドライト/フォグライトに該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isHeadLightFogLightByAbbreviationId(abbreviationId) {
    return ['LT'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がパワーウィンドウ（運転席）に該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isPowerWindowDriversSeatByAbbreviationId(abbreviationId) {
    return ['PWD'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がパワーウィンドウ（助手席）に該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isPowerWindowPassengerSeatByAbbreviationId(abbreviationId) {
    return ['PWP'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がパワーウィンドウ（後席右）に該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isPowerWindowRearSeatRightByAbbreviationId(abbreviationId) {
    return ['PWRR'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がパワーウィンドウ（後席左）に該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isPowerWindowRearSeatLeftByAbbreviationId(abbreviationId) {
    return ['PWRL'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称が後退時ブレーキアシストに該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isReverseBrakeAssistByAbbreviationId(abbreviationId) {
    return ['RAB'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がハイブリッドパワートレインコントロールに該当するか判定する。
   * (Protocol: FHI_CAN/Phase5/Phase6)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isHybridPowertrainControlByAbbreviationId(abbreviationId) {
    return ['HPC'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称が単眼カメラに該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isMonocularCameraByAbbreviationId(abbreviationId) {
    return ['MC'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称が前側方レーダに該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isFrontCornerRadarByAbbreviationId(abbreviationId) {
    return ['FCRR', 'FCRL'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称が電動ブースターに該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isElectricBrakeBoosterByAbbreviationId(abbreviationId) {
    return ['EBB'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がドライブモータに該当するか判定する。
   * (Protocol: Phase5/Phase6)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isDriveMotorByAbbreviationId(abbreviationId) {
    return ['DM'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称が高電圧バッテリに該当するか判定する。
   * (Protocol: Phase5/Phase6)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isHighVoltageBatteryByAbbreviationId(abbreviationId) {
    return ['HVB'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称が乗員検知に該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isOccupantDetectionByAbbreviationId(abbreviationId) {
    return ['OCPT'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がフロントサイドカメラ/マルチビューモニタに該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isFrontSideCameraMultiViewMonitorByAbbreviationId(abbreviationId) {
    return ['FSC'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がADAS統合ECUに該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isAdasEcuByAbbreviationId(abbreviationId) {
    return ['ADAS'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がベンチレーションシートに該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isVentilationSeatsByAbbreviationId(abbreviationId) {
    return ['VS'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がブレーキ負圧ポンプに該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isBrakeVacuumPumpByAbbreviationId(abbreviationId) {
    return ['BVP'].includes(abbreviationId);
  }

  /**
   * 診断システムID略称がパワーステアリングに該当するか判定する。
   * (Protocol: FHI_CAN)
   * @param {string} abbreviationId 診断システムID略称
   * @returns {boolean} 該当する場合はtrue、該当しない場合はfalse
   */
  static isPowerSteeringByAbbreviationId(abbreviationId) {
    return ['PS'].includes(abbreviationId);
  }
}

module.exports = DiagSystemUtils;
